var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReversal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFE6BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0957 18.0019L12.2861 21.8114M12.2861 21.8114L16.0957 25.6209M12.2861 21.8114H23.7147M19.9052 10.3828L23.7147 14.1923M23.7147 14.1923L19.9052 18.0019M23.7147 14.1923H12.2861",
    stroke: "#F99E00",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReversal);
export default __webpack_public_path__ + "static/media/Reversal.dac6f54daf6eed2ec79bc021bb8cc1b7.svg";
export { ForwardRef as ReactComponent };